import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { hardNavigateFromMeetingWizard, isMeetingWizardPath } from '../utils/meetingWizardPaths';

function resolvePath(to) {
  if (typeof to === 'string') return to;
  if (to && typeof to === 'object' && typeof to.pathname === 'string') {
    return `${to.pathname}${to.search || ''}${to.hash || ''}`;
  }
  return '';
}

/**
 * navigate با fallback به full reload هنگام خروج از ویزارد جلسه.
 */
export function usePanelNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to, options) => {
      const target = resolvePath(to);
      const leavingWizard =
        isMeetingWizardPath(location.pathname) &&
        target &&
        !isMeetingWizardPath(target.split('?')[0]);

      if (leavingWizard && hardNavigateFromMeetingWizard(target)) {
        return;
      }

      navigate(to, options);
    },
    [navigate, location.pathname],
  );
}
